import type { fabric } from 'fabric';

/** Normalize CSS / Fabric color strings to #rrggbb when possible. */
export function colorToHex(input: unknown): string | null {
  if (typeof input !== 'string' || !input || input === 'transparent') return null;
  const s = input.trim();
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(s)) {
    if (s.length === 4) {
      return `#${s[1]}${s[1]}${s[2]}${s[2]}${s[3]}${s[3]}`.toLowerCase();
    }
    return s.toLowerCase();
  }

  try {
    const ctx = document.createElement('canvas').getContext('2d');
    if (!ctx) return null;
    ctx.fillStyle = '#000000';
    ctx.fillStyle = s;
    const computed = ctx.fillStyle;
    const m = computed.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (!m) return null;
    const hex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${hex(+m[1])}${hex(+m[2])}${hex(+m[3])}`;
  } catch {
    return null;
  }
}

/**
 * Sample a usable solid color from a Fabric object (fill → stroke → gradient stop).
 */
export function sampleColorFromObject(obj: fabric.Object | null | undefined): string | null {
  if (!obj) return null;

  const fill = obj.fill as unknown;
  if (typeof fill === 'string') {
    const hex = colorToHex(fill);
    if (hex) return hex;
  } else if (fill && typeof fill === 'object' && 'colorStops' in (fill as object)) {
    const stops = (fill as { colorStops?: Array<{ color?: string }> }).colorStops;
    const first = stops?.[0]?.color;
    const hex = colorToHex(first);
    if (hex) return hex;
  }

  return colorToHex(obj.stroke);
}
